/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Template_RemoveInputs */

const en_us2_coaching_template_remove = /** @type {(inputs: Coaching_Template_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const pt_br2_coaching_template_remove = /** @type {(inputs: Coaching_Template_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar`)
};

const pt_pt2_coaching_template_remove = /** @type {(inputs: Coaching_Template_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar`)
};

/** @type {(inputs: Coaching_Template_RemoveInputs) => LocalizedString} */
const es_419_coaching_template_remove = en_us2_coaching_template_remove;

/** @type {(inputs: Coaching_Template_RemoveInputs) => LocalizedString} */
const fr_fr2_coaching_template_remove = en_us2_coaching_template_remove;

/** @type {(inputs: Coaching_Template_RemoveInputs) => LocalizedString} */
const de_de2_coaching_template_remove = en_us2_coaching_template_remove;

/** @type {(inputs: Coaching_Template_RemoveInputs) => LocalizedString} */
const it_it2_coaching_template_remove = en_us2_coaching_template_remove;

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Coaching_Template_RemoveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_template_remove = /** @type {((inputs?: Coaching_Template_RemoveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Template_RemoveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_template_remove(inputs)
	if (locale === "es-419") return es_419_coaching_template_remove(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_template_remove(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_template_remove(inputs)
	if (locale === "de-DE") return de_de2_coaching_template_remove(inputs)
	if (locale === "it-IT") return it_it2_coaching_template_remove(inputs)
	return en_us2_coaching_template_remove(inputs)
});
export { coaching_template_remove as "coaching.template_remove" }